import { render, staticRenderFns } from "./ListClient.vue?vue&type=template&id=fecb7c6e&lang=pug"
import script from "./ListClient.vue?vue&type=script&lang=js"
export * from "./ListClient.vue?vue&type=script&lang=js"
import style0 from "./ListClient.vue?vue&type=style&index=0&id=fecb7c6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports